import { useEffect, useRef } from 'react'

import { lastConfirmedId } from 'features/TeamChat/api/teamChat.pending'
import type { TeamMessage } from 'features/TeamChat/api/teamChat.types'
import { DING_GAP_MS } from 'features/TeamChat/teamChat.constants'
import { playDing } from 'features/TeamChat/sound/teamDing'

type Args = { messages?: TeamMessage[]; quiet: boolean; play?: () => void }

const isFromOthers = (m: TeamMessage, seenId: number) => m.id > seenId && !m.is_mine && !m.pending

// Dings once for colleague messages that arrive after the first load, unless the chat is on screen.
export const useIncomingDing = ({ messages, quiet, play = playDing }: Args): void => {
  const seenId = useRef<number | null>(null)
  const lastRing = useRef(0)

  useEffect(() => {
    if (!messages) return
    const newest = lastConfirmedId(messages) ?? 0
    const seen = seenId.current
    seenId.current = Math.max(seen ?? 0, newest)
    if (seen === null || quiet || !messages.some((m) => isFromOthers(m, seen))) return
    if (Date.now() - lastRing.current < DING_GAP_MS) return
    lastRing.current = Date.now()
    play()
  }, [messages, quiet, play])
}
